var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 mb-3"},[_c('span',{class:_vm.CSS_COMPUTED},[_vm._v(_vm._s(_vm.valor))]),_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }